import {PgnRawLayerGroup} from './pgn-raw-layer-group';
import {PgnLayerRenderer} from './pgn-layer-renderer';

export class PgnLayerGroup extends PgnRawLayerGroup<PgnLayerRenderer> {
}
